import {Component, OnInit} from '@angular/core';
import {BasePageComponent} from "../../base-page.component";
import {WorkService} from "../../services/domain/work.service";
import {StudyService} from "../../services/domain/study.service";
import {
  AnagraficaUtenteAttestatoDto,
  AnagraficaUtenteConoscenzeDto,
  AnagraficaUtenteIstruzioneDto,
  AnagraficaUtenteLingueDto,
  AnagraficaUtenteLivelloIstruzioneDto,
  Attestato,
  Conoscenze,
  GetIstruzioneViewModel,
  Lingua,
  LivelloIstruzione
} from "../../models/istruzione.models";
import {SharedEnumModelKeyValue} from "../../models/shared.models";
import {AuthService} from "../../services/auth.service";
import {ConfirmationService} from "primeng/api";
import {UtilsService} from "../../services/utils.service";

@Component({
  selector: 'app-study',
  templateUrl: './study.component.html',
  styleUrls: ['./study.component.css'],
  providers : [StudyService,ConfirmationService]
})
export class StudyComponent extends BasePageComponent  implements OnInit{
  constructor(private studyService : StudyService,
              private confirmationService : ConfirmationService) {
    super();

  }

  public lastStudy: AnagraficaUtenteIstruzioneDto = new AnagraficaUtenteIstruzioneDto();
  public studyList : AnagraficaUtenteIstruzioneDto[] = [];
  public studySelected : AnagraficaUtenteIstruzioneDto = new AnagraficaUtenteIstruzioneDto();
  public livelloIstruzione : LivelloIstruzione = new LivelloIstruzione();
  public studyLevelSelected : AnagraficaUtenteLivelloIstruzioneDto = new AnagraficaUtenteLivelloIstruzioneDto();
  public tmp : AnagraficaUtenteIstruzioneDto[] = [];
  public lstTitoloStudio : AnagraficaUtenteLivelloIstruzioneDto[] = [];
  public lstSettore : AnagraficaUtenteLivelloIstruzioneDto[] = [];
  public lstSpecializzazione : AnagraficaUtenteLivelloIstruzioneDto[] = [];
  public attestedSelected : AnagraficaUtenteAttestatoDto = new AnagraficaUtenteAttestatoDto();
  public markList : number[] = [];
  public profileLanguage : AnagraficaUtenteLingueDto[] = [];
  public selectedLanguage : AnagraficaUtenteLingueDto = new AnagraficaUtenteLingueDto();
  public languageList : Lingua[] = [];
  public languageRateList : SharedEnumModelKeyValue[] = [];
  public profileAttesteds : AnagraficaUtenteAttestatoDto[] = [];
  public computerKnowledges : AnagraficaUtenteConoscenzeDto[] = [];
  public conoscenzeLista : Conoscenze[] = [];
  public conoscenzeRateList: SharedEnumModelKeyValue[] = [];
  public selectedConoscenze: AnagraficaUtenteConoscenzeDto = new AnagraficaUtenteConoscenzeDto();
  public attestedTypesList : Attestato[] = [];
  public showDialogStudy : boolean = false;
  public headerDialogStudy : string = "";
  public showAttestedDialog : boolean = false;
  public headerDialogAttested : string = "";
  public showLangDialog : boolean = false;
  public headerLangDialog : string = "";
  public showInformationTecDialog : boolean = false;
  public headerInformationTecDialog : string = "";
  public istruzioneModel : GetIstruzioneViewModel = new GetIstruzioneViewModel();
  public isVisibleSettore : boolean = false;
  public isVisibleSpecializzazione : boolean = false;


  ngOnInit(): void {
    this.getProfileStudy();
    this.getProfileLanguage();
    this.getLanguageList();
    this.getLanguageRate();
    this.getProfileAttested();
    this.getAttestedTypes();
    this.getComputerKnowledges();
    this.getConoscenze();
    this.setMarkList();
    this.getComputerRate();
  }

  public getStudyList(event? : any) {
    this.istruzioneModel.Livello = 1;
    this.istruzioneModel.Filtro = event.query;
    this.istruzioneModel.IdParent = this.livelloIstruzione.TitoloStudio.IdLivelloIstruzione;
    if(this.istruzioneModel.IdParent != 0){
      this.istruzioneModel.IdParent = 0;
    }
    this.asyncCall(() => this.studyService.getTypeStudyTitleList(this.istruzioneModel), response => {
      this.lstTitoloStudio = response.Items || [];
    });
  }

  public getSettore(event? : any) {
    this.istruzioneModel.Livello = 2;
    this.istruzioneModel.Filtro = event.query;
    this.istruzioneModel.IdParent = this.livelloIstruzione.TitoloStudio.IdLivelloIstruzione;
    this.asyncCall(() => this.studyService.getTypeStudyTitleList(this.istruzioneModel), response => {
      this.lstSettore = response.Items || [];
    });
  }

  public getSpecializzazione(event? : any) {
    this.istruzioneModel.Livello = 3;
    this.istruzioneModel.Filtro = event.query;
    this.istruzioneModel.IdParent = this.livelloIstruzione.Settore.IdLivelloIstruzione;
    this.asyncCall(() => this.studyService.getTypeStudyTitleList(this.istruzioneModel), response => {
      this.lstSpecializzazione = response.Items || [];
    });
  }

  public clearTitoloStudio(){
    this.livelloIstruzione.TitoloStudio = {
      IdLivelloIstruzione: 0,
      IdParent: 0,
      Descrizione: "",
      Livello: 0
    }
  }
  public clearSettore(){
    this.isVisibleSettore = false;
    this.isVisibleSpecializzazione = false;
    if(this.livelloIstruzione.TitoloStudio.IdLivelloIstruzione != 1){
      this.isVisibleSettore = true;
      this.livelloIstruzione.Settore = {
        IdLivelloIstruzione: 0,
        IdParent: 0,
        Descrizione:"",
        Livello: 0
      };
    }
  }
  public clearSpecializzazione(){
    if(this.livelloIstruzione.Settore.IdLivelloIstruzione != 8 && this.livelloIstruzione.Settore.IdLivelloIstruzione != 9){
      this.isVisibleSpecializzazione = true;
      this.livelloIstruzione.Specializzazione = {
        IdLivelloIstruzione: 0,
        IdParent: 0,
        Descrizione:"",
        Livello: 0
      };
    }
  }

  public getProfileStudy(){
    this.asyncCall(() => this.studyService.getProfileStudy(AuthService.LoggedUser?.profileId ?? 0), response => {
      this.studyList = response.Items || [];
      if(this.studyList[0] != null){
        this.lastStudy = this.studyList[0];
      }
    });
  }
  public studyUpsert(){
    this.studySelected.AnnoConseguimento = parseInt(this.studySelected.AnnoConseguimentoStr);
    this.studySelected.VotoConseguimento = this.studySelected.VotoConseguimento + "/" + this.studySelected.VotoMassimo;
    this.studySelected.IdAnagraficaUtente = AuthService.LoggedUser?.profileId ?? 0;
    this.studySelected.TitoloStudio = this.livelloIstruzione.Specializzazione.Descrizione !== ""
      ? this.livelloIstruzione.Specializzazione.Descrizione
      : this.livelloIstruzione.Settore.Descrizione;
    this.studySelected.IdLivelloIstruzione = this.livelloIstruzione.Specializzazione.IdLivelloIstruzione !== 0
      ? this.livelloIstruzione.Specializzazione.IdLivelloIstruzione
      : this.livelloIstruzione.Settore.IdLivelloIstruzione;
    this.livelloIstruzione.Settore = this.livelloIstruzione.Specializzazione;
    if(this.livelloIstruzione.TitoloStudio.IdLivelloIstruzione == 1){
      this.studySelected.IdLivelloIstruzione = this.livelloIstruzione.TitoloStudio.IdLivelloIstruzione;
      this.studySelected.TitoloStudio = this.livelloIstruzione.TitoloStudio.Descrizione;
    }
    if(this.studySelected.IdLivelloIstruzione == 0){
      this.showError("Completare i campi obbligatori")
    }
    else{
      this.asyncCall(() => this.studyService.profileStudyUpsert(this.studySelected), response => {
        this.showMessageSaveCompleted();
        this.getProfileStudy();
        this.setLastStudy();
        this.closeDialogStudy();
      });
    }
  }
  public studyDelete(idStudy : number){
    this.confirmationService.confirm({
      message: 'Sicuro di voler eliminare questo titolo di studio?',
      header: 'Richiesta conferma',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.asyncCall(() => this.studyService.profileStudyDelete(idStudy), response => {
          this.showSuccess("Dati eliminati correttamente");
          this.getProfileStudy();
        });
      }
    });
  }

  public getProfileLanguage(){
    this.asyncCall(() => this.studyService.getProfileLanguage(AuthService.LoggedUser?.profileId ?? 0), response => {
      this.profileLanguage = response.Items || [];
    });
  }

  public getLanguageList(){
    this.asyncCall(() => this.studyService.getLanguage(), response => {
      this.languageList = response.Items || [];
    });
  }

  public getLanguageRate(){
    this.asyncCall(() => this.studyService.getRateLanguage(), response => {
      this.languageRateList = response.Items || [];
    });
  }

  public profileLangUpsert(){
    this.selectedLanguage.IdAnagraficaUtente = AuthService.LoggedUser?.profileId ?? 0;
    this.asyncCall(() => this.studyService.profileLangUpsert(this.selectedLanguage), response => {
      this.showMessageSaveCompleted();
      this.getProfileLanguage();
      this.closeDialogLang();
    });
  }

  public profileLanguageDelete(id : number){
    this.confirmationService.confirm({
      message: 'Sicuro di voler elimianre questa lingua?',
      header: 'Richiesta conferma',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.asyncCall(() => this.studyService.profileLangdDelete(id), response => {
          this.showSuccess("Dati eliminati correttamente");
          this.getProfileLanguage();
        });
      }
    });
  }

  public getProfileAttested(){
    this.asyncCall(() => this.studyService.getProfileAttested(AuthService.LoggedUser?.profileId ?? 0), response => {
      this.profileAttesteds = response.Items || [];
    });
  }

  public getAttestedTypes(){
    this.asyncCall(() => this.studyService.getAttestedTypes(), response => {
      this.attestedTypesList = response.Items || [];
      this.getProfileAttested();
    });
  }

  public profileAttestedUpsert(){
    this.attestedSelected.IdAnagraficaUtente = AuthService.LoggedUser?.profileId ?? 0;
    this.attestedSelected.DataConseguimento = UtilsService.SetHourTO_DATE(this.attestedSelected.DataConseguimento);
    this.asyncCall(() => this.studyService.profileAttestedUpsert(this.attestedSelected), response => {
      this.showMessageSaveCompleted();
      this.getProfileAttested();
      this.closeDialogAttested();
    });
  }

  public profileAttestedDelete(id : number){
    this.confirmationService.confirm({
      message: 'Sicuro di voler eliminare questo titolo di studio?',
      header: 'Richiesta conferma',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.asyncCall(() => this.studyService.profileAttestedDelete(id), response => {
          this.showSuccess("Dati eliminati correttamente");
          this.getProfileAttested();
        });
      }
    });
  }

  public getComputerKnowledges(){
    this.asyncCall(() => this.studyService.getComputerKnowledges(AuthService.LoggedUser?.profileId ?? 0), response => {
      this.computerKnowledges = response.Items || [];
    });
  }

  public addStudy(){
    this.headerDialogStudy = 'Aggiungi formazione';
    this.showDialogStudy = true;
    this.studySelected = new AnagraficaUtenteIstruzioneDto();
    this.clearTitoloStudio();
    this.clearSettore();
    this.clearSpecializzazione();
  }

  public addAttested(){
    this.headerDialogAttested = 'Aggiungi attestato';
    this.showAttestedDialog = true;
    this.attestedSelected = new AnagraficaUtenteAttestatoDto();
  }

  public addLang(){
    this.headerLangDialog = 'Aggiungi lingua';
    this.showLangDialog = true;
    this.selectedLanguage = new AnagraficaUtenteLingueDto();
  }

  public addInfTec(){
    this.headerInformationTecDialog = 'Aggiungi competenza informatica';
    this.showInformationTecDialog = true;
    this.selectedConoscenze = new AnagraficaUtenteConoscenzeDto();
  }



  public closeDialogStudy(){
    this.showDialogStudy = false;
  }

  public closeDialogAttested(){
    this.showAttestedDialog = false;
  }

  public closeDialogLang(){
    this.showLangDialog = false;
  }

  public closeDialogInfTec(){
    this.showInformationTecDialog = false;
  }

  public getConoscenze(){
    this.asyncCall(() => this.studyService.getKnowledges(), response => {
      this.conoscenzeLista = response.Items || [];
    });
  }

  public getComputerRate(){
    this.asyncCall(() => this.studyService.getKnowledgesRate(), response => {
      this.conoscenzeRateList = response.Items || [];
    });
  }

  public computerKnowledgesUpsert(){
    this.selectedConoscenze.IdAnagraficaUtente = AuthService.LoggedUser?.profileId ?? 0;
    this.asyncCall(() => this.studyService.computerKnowledgesUpsert(this.selectedConoscenze), response => {
      this.showMessageSaveCompleted();
      this.getComputerKnowledges();
      this.closeDialogInfTec();
    });
  }

  public profileConoscenzeDelete(id : number){
    this.confirmationService.confirm({
      message: 'Sicuro di voler eliminare questa conoscenza?',
      header: 'Richiesta conferma',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.asyncCall(() => this.studyService.profileComputerKnowledgesDelete(id), response => {
          this.showSuccess("Dati eliminati correttamente");
          this.getComputerKnowledges();
        });
      }
    });
  }

  public setLastStudy(){
    for(let i =0; i < this.studyList.length; i++){
      this.lastStudy= this.studyList[i];
      this.studyList.splice(i,1);
      return;
    }
  }

  public editLastStudy(lastStudy : AnagraficaUtenteIstruzioneDto){
    this.headerDialogStudy = "Modifica formazione";
    this.studySelected = lastStudy;
    this.showDialogStudy = true;
  }



  private setMarkList(){
    this.markList = [];
    for (let i=36; i <= 110; i++)
    {
      this.markList.push(i);
    }
  }

}
